export default {
  title: 'Ingresar nueva contraseña',
  changePasswordButton: 'Restablecer contraseña',
  returnLogin: {
    button: 'Iniciar sesión',
  },
  success: {
    label: 'La contraseña ha sido actualizada exitosamente.'
  },
  password: {
    inputLabel: 'Contraseña',
    confirmInputLabel: 'Confirmar contraseña'
  },
  badConfirmPassword: 'La contraseña no coincide.',
  invalidToken: {
    title: 'Este enlace ya fue utilizado',
    button: 'Ir a Inicio de sesión',
    label: '¿Problemas para acceder a tu cuenta?'
  }
}
